import * as React from "react";
const SvgFiRrUserKey = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-user-key_svg__a)">
      <path
        fill="#062147"
        d="M20.061 12.939a1.5 1.5 0 1 1-2.12 2.121 1.5 1.5 0 0 1 2.12-2.121m2.328 5.449a5.52 5.52 0 0 1-4.413 1.585l-3.133 3.133a3.02 3.02 0 0 1-2.121.879h-1.714a2.003 2.003 0 0 1-1.997-1.99l-.009-1.988a1.49 1.49 0 0 1 .437-1.064 1.5 1.5 0 0 1 1.063-.442h.49l.004-.512a1.504 1.504 0 0 1 1.5-1.488h.762v-.393a5.47 5.47 0 0 1 2.138-6.15c1.805-1.251 4.244-1.286 6.071-.093a5.53 5.53 0 0 1 2.503 4.066 5.48 5.48 0 0 1-1.581 4.459zm-.408-4.253c-.11-1.07-.682-1.993-1.607-2.597-1.154-.754-2.696-.728-3.839.062a3.49 3.49 0 0 0-1.33 4.027 1 1 0 0 1 .054.322v1.55a1 1 0 0 1-1 1h-1.265l-.007 1.008a1 1 0 0 1-1 .992h-.98l.006 1.485h1.711c.263 0 .52-.106.707-.293l3.487-3.487a.99.99 0 0 1 .901-.273 3.5 3.5 0 0 0 3.157-.957 3.49 3.49 0 0 0 1.005-2.839M2 6c0-3.309 2.691-6 6-6s6 2.691 6 6-2.691 6-6 6-6-2.691-6-6m2 0c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4-4 1.794-4 4m5.99 9.213a1 1 0 0 0-.848-1.132A8 8 0 0 0 8 14c-4.411 0-8 3.589-8 8v1a1 1 0 1 0 2 0v-1a6.006 6.006 0 0 1 6.858-5.938 1.006 1.006 0 0 0 1.132-.849"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-user-key_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUserKey;
